import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import documentReducer from './document_reducer';
import authReducer from './auth_reducer';
import userReducer from './user_reducer';
import projectReducer from './project_reducer';
import consultantReducer from './consultant_reducer';
import dashboardReducer from './dashboard_reducer';
import programReducer from './program_reducer';
import rexReducer from './rex_reducer';
import eightDReducer from './eightd_reducer';
import filterReducer from './filter_reducer';
import quaterlyReducer from './quaterlyreport_reducer';
import chatbotReducer from './chatbot_reducer';
import { localizeReducer } from 'react-localize-redux';


const filterPersistConfig = {
  key: 'filter',
  storage,
}

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  project: projectReducer,
  consultant: consultantReducer,
  dashboard: dashboardReducer,
  localize: localizeReducer,
  program: programReducer,
  rex: rexReducer,
  eightD: eightDReducer,
    quaterlyReport: quaterlyReducer,
    chatbot: chatbotReducer,
  document:documentReducer,
  filter: persistReducer(filterPersistConfig, filterReducer)
});

export default rootReducer;
